import React, { useState } from "react";
import { useLang } from "@/lib/lang";
import { api, useAuth } from "@/lib/auth";
import { Camera, Mic, ShieldCheck } from "lucide-react";

export default function CameraConsentModal({ onDecision }) {
    const { t } = useLang();
    const { refresh } = useAuth();
    const [loading, setLoading] = useState(false);

    const accept = async () => {
        setLoading(true);
        try {
            await api.post("/auth/camera-consent");
            await refresh();
        } catch (e) {
            // non-fatal — still let them continue with camera this session
        } finally {
            setLoading(false);
            onDecision(true);
        }
    };

    const decline = () => onDecision(false);

    return (
        <div className="fixed inset-0 z-[100] bg-black/60 flex items-center justify-center p-6" data-testid="camera-consent-modal">
            <div className="bg-white max-w-md w-full rounded-lg border border-slate-200 p-8">
                <div className="w-14 h-14 rounded-full bg-brand/10 flex items-center justify-center mb-6">
                    <ShieldCheck size={26} className="text-brand" />
                </div>
                <h2 className="font-display text-2xl mb-3 tracking-tight" data-testid="camera-consent-title">
                    {t("consent.title")}
                </h2>
                <p className="text-sm text-slate-600 leading-relaxed mb-4">{t("consent.body")}</p>
                <ul className="text-xs text-slate-500 space-y-2 mb-6">
                    <li className="flex items-start gap-2">
                        <Camera size={13} className="mt-0.5 text-brand flex-shrink-0" /> {t("consent.point_video")}
                    </li>
                    <li className="flex items-start gap-2">
                        <Mic size={13} className="mt-0.5 text-brand flex-shrink-0" /> {t("consent.point_audio")}
                    </li>
                </ul>
                <div className="flex flex-col gap-2">
                    <button onClick={accept} disabled={loading} className="btn-primary w-full justify-center" data-testid="consent-accept-btn">
                        {t("consent.accept")}
                    </button>
                    <button onClick={decline} className="btn-ghost w-full justify-center text-sm" data-testid="consent-decline-btn">
                        {t("consent.decline")}
                    </button>
                </div>
            </div>
        </div>
    );
}
